import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Output, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["zoomContainer"];
const _c1 = ["imageThumbnail"];
const _c2 = ["fullSizeImage"];
const _c3 = a0 => ({
  ngxImageZoomFullContainer: true,
  ngxImageZoomLensEnabled: a0
});
let NgxImageZoomComponent = /*#__PURE__*/(() => {
  class NgxImageZoomComponent {
    constructor(renderer, changeDetectorRef) {
      this.renderer = renderer;
      this.changeDetectorRef = changeDetectorRef;
      this.zoomScroll = new EventEmitter();
      this.zoomPosition = new EventEmitter();
      this.imagesLoaded = new EventEmitter();
      this.enableLens = false;
      this.lensBorderRadius = 0;
      this.thumbWidth = 0;
      this.thumbHeight = 0;
      this.fullWidth = 0;
      this.fullHeight = 0;
      this.lensWidth = 100;
      this.lensHeight = 100;
      this.zoomMode = 'hover';
      this.magnification = 1;
      this.enableScrollZoom = false;
      this.scrollStepSize = 0.1;
      this.circularLens = false;
      this.minZoomRatio = 1;
      this.maxZoomRatio = 2;
      this.xRatio = 0;
      this.yRatio = 0;
      this.zoomingEnabled = false;
      this.zoomFrozen = false;
      this.isReady = false;
      this.thumbImageLoaded = false;
      this.fullImageLoaded = false;
      this.latestMouseLeft = -1;
      this.latestMouseTop = -1;
      this.eventListeners = [];
      this.altText = '';
      this.titleText = '';
    }
    set setThumbImage(thumbImage) {
      this.thumbImageLoaded = false;
      this.setIsReady(false);
      this.thumbImage = thumbImage;
    }
    set setFullImage(fullImage) {
      this.fullImageLoaded = false;
      this.setIsReady(false);
      this.fullImage = fullImage;
    }
    set setZoomMode(zoomMode) {
      if (NgxImageZoomComponent.validZoomModes.some(m => m === zoomMode)) {
        this.zoomMode = zoomMode;
      }
    }
    set setMagnification(magnification) {
      this.magnification = Number(magnification) || this.magnification;
      this.zoomScroll.emit(this.magnification);
    }
    set setMinZoomRatio(minZoomRatio) {
      const ratio = Number(minZoomRatio) || this.minZoomRatio || this.baseRatio || 0;
      this.minZoomRatio = Math.max(ratio, this.baseRatio || 0);
    }
    set setMaxZoomRatio(maxZoomRatio) {
      this.maxZoomRatio = Number(maxZoomRatio) || this.maxZoomRatio;
    }
    set setScrollStepSize(stepSize) {
      this.scrollStepSize = Number(stepSize) || this.scrollStepSize;
    }
    set setEnableLens(enable) {
      this.enableLens = Boolean(enable);
    }
    set setLensWidth(width) {
      this.lensWidth = Number(width) || this.lensWidth;
    }
    set setLensHeight(height) {
      this.lensHeight = Number(height) || this.lensHeight;
    }
    set setCircularLens(enable) {
      this.circularLens = Boolean(enable);
    }
    set setEnableScrollZoom(enable) {
      this.enableScrollZoom = Boolean(enable);
    }
    ngOnInit() {
      this.setUpEventListeners();
    }
    ngOnChanges() {
      if (this.enableLens) {
        if (this.circularLens) {
          this.lensBorderRadius = this.lensWidth / 2;
        } else {
          this.lensBorderRadius = 0;
        }
      }
      this.calculateRatioAndOffset();
      this.calculateImageAndLensPosition();
    }
    ngOnDestroy() {
      this.eventListeners.forEach(destroyFn => destroyFn());
    }
    /**
     * Template helper methods
     */
    onThumbImageLoaded() {
      this.thumbImageLoaded = true;
      this.checkImagesLoaded();
    }
    onFullImageLoaded() {
      this.fullImageLoaded = true;
      this.checkImagesLoaded();
    }
    setUpEventListeners() {
      const nativeElement = this.zoomContainer.nativeElement;
      switch (this.zoomMode) {
        case 'hover':
          this.eventListeners.push(this.renderer.listen(nativeElement, 'mouseenter', event => this.hoverMouseEnter(event)), this.renderer.listen(nativeElement, 'mouseleave', () => this.hoverMouseLeave()), this.renderer.listen(nativeElement, 'mousemove', event => this.hoverMouseMove(event)));
          break;
        case 'toggle':
          this.eventListeners.push(this.renderer.listen(nativeElement, 'click', event => this.toggleClick(event)));
          break;
        case 'toggle-click':
          this.eventListeners.push(this.renderer.listen(nativeElement, 'click', event => this.toggleClick(event)), this.renderer.listen(nativeElement, 'mouseleave', () => this.clickMouseLeave()), this.renderer.listen(nativeElement, 'mousemove', event => this.clickMouseMove(event)));
          break;
        case 'click':
          this.eventListeners.push(this.renderer.listen(nativeElement, 'click', event => this.clickStarter(event)), this.renderer.listen(nativeElement, 'mouseleave', () => this.clickMouseLeave()), this.renderer.listen(nativeElement, 'mousemove', event => this.clickMouseMove(event)));
          break;
        case 'hover-freeze':
          this.eventListeners.push(this.renderer.listen(nativeElement, 'mouseenter', event => this.hoverFreezeMouseEnter(event)), this.renderer.listen(nativeElement, 'mouseleave', () => this.hoverFreezeMouseLeave()), this.renderer.listen(nativeElement, 'mousemove', event => this.hoverFreezeMouseMove(event)), this.renderer.listen(nativeElement, 'click', event => this.hoverFreezeClick(event)));
      }
      if (this.enableScrollZoom) {
        // Chrome: 'mousewheel', Firefox: 'DOMMouseScroll', IE: 'onmousewheel'
        this.eventListeners.push(this.renderer.listen(nativeElement, 'mousewheel', event => this.onMouseWheel(event)), this.renderer.listen(nativeElement, 'DOMMouseScroll', event => this.onMouseWheel(event)), this.renderer.listen(nativeElement, 'onmousewheel', event => this.onMouseWheel(event)));
      }
      if (this.enableLens && this.circularLens) {
        this.lensBorderRadius = this.lensWidth / 2;
      }
    }
    checkImagesLoaded() {
      this.calculateRatioAndOffset();
      if (this.thumbImageLoaded && this.fullImageLoaded) {
        this.calculateImageAndLensPosition();
        this.setIsReady(true);
      }
    }
    setIsReady(value) {
      this.isReady = value;
      this.imagesLoaded.emit(value);
    }
    /**
     * Zoom position setters
     */
    setZoomPosition(left, top) {
      this.latestMouseLeft = Number(left) || this.latestMouseLeft;
      this.latestMouseTop = Number(top) || this.latestMouseTop;
      const c = {
        x: this.latestMouseLeft,
        y: this.latestMouseTop
      };
      this.zoomPosition.emit(c);
    }
    /**
     * Mouse wheel event
     */
    onMouseWheel(event) {
      // Don't eat events if zooming isn't active
      if (!this.zoomingEnabled || this.zoomFrozen) {
        return;
      }
      event = window.event || event; // old IE
      const direction = Math.max(Math.min(event.wheelDelta || -event.detail, 1), -1);
      if (direction > 0) {
        // up
        this.setMagnification = Math.min(this.magnification + this.scrollStepSize, this.maxZoomRatio);
      } else {
        // down
        this.setMagnification = Math.max(this.magnification - this.scrollStepSize, this.minZoomRatio);
      }
      this.calculateRatio();
      this.calculateZoomPosition(event);
      // Prevent scrolling on page.
      event.returnValue = false; // IE
      if (event.preventDefault) {
        event.preventDefault(); // Chrome & FF
      }
    }
    /**
     * Hover mode
     */
    hoverMouseEnter(event) {
      this.zoomOn(event);
    }
    hoverMouseLeave() {
      this.zoomOff();
    }
    hoverMouseMove(event) {
      this.calculateZoomPosition(event);
    }
    /**
     * Toggle mode
     */
    toggleClick(event) {
      if (this.zoomingEnabled) {
        this.zoomOff();
      } else {
        this.zoomOn(event);
      }
    }
    /**
     * Click mode
     */
    clickStarter(event) {
      if (this.zoomingEnabled === false) {
        this.zoomOn(event);
      }
    }
    clickMouseLeave() {
      this.zoomOff();
    }
    clickMouseMove(event) {
      if (this.zoomingEnabled) {
        this.calculateZoomPosition(event);
      }
    }
    /**
     * Hover freeze mode
     */
    hoverFreezeMouseEnter(event) {
      if (this.zoomingEnabled && !this.zoomFrozen) {
        this.zoomOn(event);
      }
    }
    hoverFreezeMouseLeave() {
      if (this.zoomingEnabled && !this.zoomFrozen) {
        this.zoomOff();
      }
    }
    hoverFreezeMouseMove(event) {
      if (this.zoomingEnabled && !this.zoomFrozen) {
        this.calculateZoomPosition(event);
      }
    }
    hoverFreezeClick(event) {
      if (this.zoomingEnabled && this.zoomFrozen) {
        this.zoomFrozen = false;
        this.zoomOff();
      } else if (this.zoomingEnabled) {
        this.zoomFrozen = true;
        this.changeDetectorRef.markForCheck();
      } else {
        this.zoomOn(event);
      }
    }
    /**
     * Private helper methods
     */
    zoomOn(event) {
      if (this.isReady) {
        this.zoomingEnabled = true;
        this.calculateRatioAndOffset();
        this.display = 'block';
        this.calculateZoomPosition(event);
        this.changeDetectorRef.markForCheck();
      }
    }
    zoomOff() {
      this.zoomingEnabled = false;
      this.display = 'none';
      this.changeDetectorRef.markForCheck();
    }
    calculateZoomPosition(event) {
      const newLeft = Math.max(Math.min(event.offsetX, this.thumbWidth), 0);
      const newTop = Math.max(Math.min(event.offsetY, this.thumbHeight), 0);
      this.setZoomPosition(newLeft, newTop);
      this.calculateImageAndLensPosition();
      this.changeDetectorRef.markForCheck();
    }
    calculateImageAndLensPosition() {
      let lensLeftMod = 0;
      let lensTopMod = 0;
      if (this.enableLens && this.latestMouseLeft > 0) {
        lensLeftMod = this.lensLeft = this.latestMouseLeft - this.lensWidth / 2;
        lensTopMod = this.lensTop = this.latestMouseTop - this.lensHeight / 2;
      }
      this.fullImageLeft = this.latestMouseLeft * -this.xRatio - lensLeftMod;
      this.fullImageTop = this.latestMouseTop * -this.yRatio - lensTopMod;
    }
    calculateRatioAndOffset() {
      this.thumbWidth = this.imageThumbnail.nativeElement.width;
      this.thumbHeight = this.imageThumbnail.nativeElement.height;
      // If lens is disabled, set lens size to equal thumb size and position it on top of the thumb
      if (!this.enableLens) {
        this.lensWidth = this.thumbWidth;
        this.lensHeight = this.thumbHeight;
        this.lensLeft = 0;
        this.lensTop = 0;
      }
      // getBoundingClientRect() ? https://stackoverflow.com/a/44008873
      this.offsetTop = this.imageThumbnail.nativeElement.getBoundingClientRect().top;
      this.offsetLeft = this.imageThumbnail.nativeElement.getBoundingClientRect().left;
      if (this.fullImage === undefined) {
        this.fullImage = this.thumbImage;
      }
      if (this.fullImageLoaded) {
        this.fullWidth = this.fullSizeImage.nativeElement.naturalWidth;
        this.fullHeight = this.fullSizeImage.nativeElement.naturalHeight;
        this.baseRatio = Math.max(this.thumbWidth / this.fullWidth, this.thumbHeight / this.fullHeight);
        // Don't allow zooming to smaller than thumbnail size
        this.minZoomRatio = Math.max(this.minZoomRatio || 0, this.baseRatio || 0);
        this.calculateRatio();
      }
    }
    calculateRatio() {
      this.magnifiedWidth = this.fullWidth * this.magnification;
      this.magnifiedHeight = this.fullHeight * this.magnification;
      this.xRatio = (this.magnifiedWidth - this.thumbWidth) / this.thumbWidth;
      this.yRatio = (this.magnifiedHeight - this.thumbHeight) / this.thumbHeight;
    }
  }
  NgxImageZoomComponent.validZoomModes = ['hover', 'toggle', 'click', 'toggle-click', 'hover-freeze'];
  NgxImageZoomComponent.ɵfac = function NgxImageZoomComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxImageZoomComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  NgxImageZoomComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxImageZoomComponent,
    selectors: [["lib-ngx-image-zoom"]],
    viewQuery: function NgxImageZoomComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
        i0.ɵɵviewQuery(_c1, 7);
        i0.ɵɵviewQuery(_c2, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zoomContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.imageThumbnail = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fullSizeImage = _t.first);
      }
    },
    inputs: {
      setThumbImage: [0, "thumbImage", "setThumbImage"],
      setFullImage: [0, "fullImage", "setFullImage"],
      setZoomMode: [0, "zoomMode", "setZoomMode"],
      setMagnification: [0, "magnification", "setMagnification"],
      setMinZoomRatio: [0, "minZoomRatio", "setMinZoomRatio"],
      setMaxZoomRatio: [0, "maxZoomRatio", "setMaxZoomRatio"],
      setScrollStepSize: [0, "scrollStepSize", "setScrollStepSize"],
      setEnableLens: [0, "enableLens", "setEnableLens"],
      setLensWidth: [0, "lensWidth", "setLensWidth"],
      setLensHeight: [0, "lensHeight", "setLensHeight"],
      setCircularLens: [0, "circularLens", "setCircularLens"],
      setEnableScrollZoom: [0, "enableScrollZoom", "setEnableScrollZoom"],
      altText: "altText",
      titleText: "titleText"
    },
    outputs: {
      zoomScroll: "zoomScroll",
      zoomPosition: "zoomPosition",
      imagesLoaded: "imagesLoaded"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 7,
    vars: 35,
    consts: [["zoomContainer", ""], ["imageThumbnail", ""], ["fullSizeImage", ""], [1, "ngxImageZoomContainer"], [1, "ngxImageZoomThumbnail", 3, "load", "alt", "title", "src"], [3, "ngClass"], [1, "ngxImageZoomFull", 3, "load", "alt", "title", "src"]],
    template: function NgxImageZoomComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3, 0)(2, "img", 4, 1);
        i0.ɵɵlistener("load", function NgxImageZoomComponent_Template_img_load_2_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onThumbImageLoaded());
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 5)(5, "img", 6, 2);
        i0.ɵɵlistener("load", function NgxImageZoomComponent_Template_img_load_5_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onFullImageLoaded());
        });
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.thumbWidth, "px")("height", ctx.thumbHeight, "px");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("alt", ctx.altText)("title", ctx.titleText)("src", ctx.thumbImage, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("display", ctx.display)("top", ctx.lensTop, "px")("left", ctx.lensLeft, "px")("width", ctx.lensWidth, "px")("height", ctx.lensHeight, "px")("border-radius", ctx.lensBorderRadius, "px");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c3, ctx.enableLens));
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("display", ctx.display)("top", ctx.fullImageTop, "px")("left", ctx.fullImageLeft, "px")("width", ctx.magnifiedWidth, "px")("height", ctx.magnifiedHeight, "px");
        i0.ɵɵproperty("alt", ctx.altText)("title", ctx.titleText)("src", ctx.fullImage, i0.ɵɵsanitizeUrl);
      }
    },
    dependencies: [i1.NgClass],
    styles: [".ngxImageZoomContainer[_ngcontent-%COMP%]{position:relative;margin:auto;overflow:hidden;pointer-events:none}.ngxImageZoomThumbnail[_ngcontent-%COMP%]{pointer-events:all}.ngxImageZoomFull[_ngcontent-%COMP%]{position:absolute;max-width:none;max-height:none;display:none;pointer-events:none}.ngxImageZoomFullContainer[_ngcontent-%COMP%]{position:absolute;overflow:hidden;pointer-events:none}.ngxImageZoomFullContainer.ngxImageZoomLensEnabled[_ngcontent-%COMP%]{border:2px solid red;cursor:crosshair;pointer-events:none}"]
  });
  return NgxImageZoomComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxImageZoomModule = /*#__PURE__*/(() => {
  class NgxImageZoomModule {}
  NgxImageZoomModule.ɵfac = function NgxImageZoomModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxImageZoomModule)();
  };
  NgxImageZoomModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxImageZoomModule
  });
  NgxImageZoomModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return NgxImageZoomModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-image-zoom
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxImageZoomComponent, NgxImageZoomModule };
